import { Component, Input } from '@angular/core'
import { Location } from '@angular/common'
import { Customer } from 'types'
import { aboutComplete, earliestUnfinishedAboutRoute } from 'logic/customer-signup'

@Component({
  selector: 'client-setup-nav',
  template: `
    <ul class="list-unstyled left-buffer top-buffer">
      <ng-template [ngIf]="!customer">
        <li class="small-bottom-buffer">
          <span class="selected">Name</span>
        </li>
      </ng-template>
      <ng-template [ngIf]="customer">
        <li [routerLink]="['clients', 'setup', customer?.id, 'business_name']" class="small-bottom-buffer" (click)="stopPropagation($event)">
          <span [class.selected]="isRouteActive('clients/new') || isRouteActive('business_name')">Name</span>
          <span class="fas fa-check small-left-buffer"></span>
        </li>
        <li [routerLink]="computeRoute()" class="small-bottom-buffer" (click)="stopPropagation($event)">
          <span [class.selected]="isRouteActive('about')">About</span>
          <span *ngIf="aboutComplete()" class="fas fa-check small-left-buffer"></span>
        </li>
        <li [routerLink]="['clients', 'setup', customer?.id, 'plan']" (click)="stopPropagation($event)">
          <span [class.selected]="isRouteActive('plan')">Plan</span>
          <span *ngIf="customer?.plan" class="fas fa-check small-left-buffer"></span>
        </li>
      </ng-template>
    </ul>
  `,
})
export class ClientSetupNavComponent {
  @Input() customer: Customer;
  private location: Location;

  constructor(location: Location) {
    this.location = location
  }

  stopPropagation(event: Event): void {
    event.stopPropagation()
  }

  isRouteActive(str: string): RegExpMatchArray {
    return this.location.path().match(str)
  }

  aboutComplete(): boolean {
    return aboutComplete(this.customer)
  }

  computeRoute(): Array<string|Object> {
    return earliestUnfinishedAboutRoute(this.customer)
  }
}
